/**
 * Rolagem manual infinita do carrossel de produção da seção "Intelligence Meno",
 * usada quando a rolagem automática (marquee CSS) está DESLIGADA no editor do tema.
 *
 * O cliente arrasta para avançar e o conteúdo (2 grupos idênticos de fotos) faz
 * loop sem emenda via translate + módulo — nunca chega ao fim. Vertical no desktop
 * (>=990px), horizontal no mobile.
 *
 * Importante: NÃO sequestra a roda do mouse (a página rola normalmente por cima da
 * seção). No toque, o CSS `touch-action: pan-y` deixa a página rolar na vertical e
 * entrega o arrasto horizontal (eixo do carrossel no mobile) para este script.
 *
 * Sem dependências/import: carregado direto via <script type="module"> na seção.
 * Reinicializa em `shopify:section:load` (editor do tema).
 */
function setupManualMarquee(media) {
  if (media.dataset.imManual === 'on') return;
  const track = media.querySelector('.intelligence-meno__media-track');
  if (!track) return;
  media.dataset.imManual = 'on';

  const mq = window.matchMedia('(min-width: 990px)');
  let vertical = mq.matches;
  let group = 0; // tamanho de UM grupo (metade da track, que tem 2 grupos)
  let offset = 0; // deslocamento acumulado em px

  const measure = () => {
    vertical = mq.matches;
    const groups = track.children.length || 1;
    // scrollHeight/scrollWidth ignoram o transform => medida estável
    group = (vertical ? track.scrollHeight : track.scrollWidth) / groups;
  };

  const apply = () => {
    if (group <= 0) return;
    const m = ((offset % group) + group) % group; // [0, group)
    track.style.transform = vertical ? `translateY(${-m}px)` : `translateX(${-m}px)`;
  };

  let dragging = false;
  let startCoord = 0;
  let startOffset = 0;

  const onDown = (event) => {
    if (event.button != null && event.button !== 0) return; // só botão primário / toque
    dragging = true;
    startCoord = vertical ? event.clientY : event.clientX;
    startOffset = offset;
    media.style.cursor = 'grabbing';
    try {
      media.setPointerCapture(event.pointerId);
    } catch (_) {}
  };

  const onMove = (event) => {
    if (!dragging) return;
    const current = vertical ? event.clientY : event.clientX;
    offset = startOffset + (startCoord - current);
    apply();
  };

  const onUp = (event) => {
    if (!dragging) return;
    dragging = false;
    if (group > 0) offset = ((offset % group) + group) % group; // normaliza (evita crescer sem limite)
    media.style.cursor = '';
    try {
      media.releasePointerCapture(event.pointerId);
    } catch (_) {}
  };

  media.addEventListener('pointerdown', onDown);
  media.addEventListener('pointermove', onMove);
  media.addEventListener('pointerup', onUp);
  media.addEventListener('pointercancel', onUp);

  const ro = new ResizeObserver(() => {
    measure();
    apply();
  });
  ro.observe(track);
  mq.addEventListener('change', () => {
    measure();
    apply();
  });

  measure();
  apply();
}

function init(root) {
  (root || document)
    .querySelectorAll('.intelligence-meno__media--manual')
    .forEach(setupManualMarquee);
}

init();
document.addEventListener('shopify:section:load', (event) => init(event.target));
